import { CustomerActionsComponent } from './customer.actions.component';

export function CustomersCtrl (
  $scope,
  $state,
  companyMessages,
  customers,
  inheritorApi
) {
  $scope.actionsCell = {
    component: {
      bindings: {
        outputs: {
          onEditClick      : event => $scope.viewCustomer(event),
          onAddVehicleClick: event => $state.go('app.vehicle', { customer_id: event.id }),
          onBookingClick   : event => $state.go('app.event', { customer_id: event.id }),
          onInvoiceClick   : event => $state.go('app.invoice', { customer_id: event.id }),
          onSMSClick       : event => $scope.sendSMS(event),
          onEmailClick     : event => $scope.sendEmail(event),
          onActivateClick  : event => $scope.activate(event),
        }
      },
      enabled: true,
      factory: CustomerActionsComponent
    },
    sortable: false,
  };

  $scope.companyMessages = companyMessages;
  $scope.customers       = customers;

  inheritorApi.inheritCtrl('CustomersLiteCtrl', $scope);
}
